import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "modal" }, null, -1)
const _hoisted_2 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueQueryDevTools = _resolveComponent("VueQueryDevTools")!
  const _component_WalletSelectModal = _resolveComponent("WalletSelectModal")!
  const _component_Notifications = _resolveComponent("Notifications")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layout))),
      _createVNode(_component_VueQueryDevTools),
      _createVNode(_component_WalletSelectModal, {
        isVisible: _ctx.isWalletSelectVisible,
        onClose: _ctx.toggleWalletSelectModal
      }, null, 8, ["isVisible", "onClose"]),
      _createVNode(_component_Notifications)
    ])
  ], 64))
}